import {useRootStore} from '@/features/core/store/store';

function useSidebarState() {
  return useRootStore((store) => ({
    sidebarIsOpen: store.settings.ui.sidebarIsOpen,
    toggleSidebar: store.toggleSidebar,
  }));
}

export {useSidebarState};
